import React, { useState, useEffect } from "react";
import logo from "../Assets/newlogo-optimized.webp";
import {
  Card,
  Row,
  Col,
  Pagination,
  Button,
  Modal,
  Form,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import { API_URI } from "../Common/data";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import ticketImage from "../Assets/ticket.png";
import { Carousel } from "react-bootstrap";
import { getUTCDateFromISTDateString } from "../Utils/dateUtils";
import { formatTimeRange } from "../Utils/timeUtils";

const cellStyle = {
  padding: "6px",
  border: "1px solid #ccc",
  textAlign: "left",
};

const cellStyleRight = {
  padding: "6px",
  border: "1px solid #ccc",
  textAlign: "right",
};

const tableHeaderStyle = {
  padding: "6px",
  border: "1px solid #ddd",
  backgroundColor: "#f0f0f0",
  fontWeight: "bold",
  textAlign: "left",
};

const tableCellStyle = {
  padding: "6px",
  border: "1px solid #ddd",
};

const BookingHistory = () => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [cancellationReason, setCancellationReason] = useState("");
  const recordsPerPage = 5;

  // Reschedule Modal State
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [rescheduleSlots, setRescheduleSlots] = useState([]);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [rescheduleError, setRescheduleError] = useState(null);
  const [rescheduleBooking, setRescheduleBooking] = useState(null);
  const [selectedSlotId, setSelectedSlotId] = useState("");
  const [rescheduleActionLoading, setRescheduleActionLoading] = useState(false);
  const [theaters, setTheaters] = useState([]);
  const [slots, setSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTheater, setSelectedTheater] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [theaterImageIndexes, setTheaterImageIndexes] = useState({});
  const [selectedTimeSlotId, setSelectedTimeSlotId] = useState(null);

  // console.log(selectedTheater)
  // console.log(selectedSlot)

  // Fetch booking history data
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URI}/booking/byself`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("cine_userToken")}`,
          },
        });
        if (response.status === 200) {
          setBookings(response.data.data); // Assuming `data` contains booking array
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Failed to fetch booking history!");
      }
    };
    fetchBookings();
  }, []);

  // Pagination logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = bookings.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(bookings.length / recordsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const getBookingTimeLabel = (booking) =>
    formatTimeRange(booking?.startTime, booking?.endTime);

  // Generate PDF for Invoice or Ticket
  // const generatePDF = (booking, type) => {
  //   const doc = new jsPDF("p", "mm", "a4");
  //   const templateId =
  //     type === "invoice" ? `invoice-${booking._id}` : `ticket-${booking._id}`;
  //   const templateElement = document.getElementById(templateId);

  //   if (!templateElement) {
  //     toast.error("Template not found!");
  //     return;
  //   }

  //   html2canvas(templateElement, { useCORS: true, scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdfWidth = doc.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //     const fileName = `${type === "invoice" ? "Invoice" : "Ticket"}_${
  //       booking.bookingName
  //     }.pdf`;
  //     doc.save(fileName);
  //   });
  // };

  const handleTheaterSelect = (theater) => {
    console.log("Selecting theater:", theater._id, theater.theater.name);
    setSelectedTheater(theater);
    setSlots(theater.slots || []);
    setSelectedSlot("");
  };

  const handleSlotClick = (val) => {
    setSelectedSlot(val._id);
    setSelectedTimeSlotId(val.timeSlotId);
  };

  const generatePDF = (booking, type) => {
    setLoading(true);
    const doc = new jsPDF("p", "mm", "a4");
    const templateId =
      type === "invoice" ? `invoice-${booking._id}` : `ticket-${booking._id}`;
    const templateElement = document.getElementById(templateId);

    if (!templateElement) {
      toast.error("Template not found!");
      return;
    }

    html2canvas(templateElement, { useCORS: true, scale: 2 }).then(
      (canvas) => {
        // const imgData = canvas.toDataURL("image/png");
        const imgData = canvas.toDataURL("image/jpeg");
        // const imgData = canvas.toDataURL("image/jpeg", 1.0);

        const pdfWidth = doc.internal.pageSize.getWidth(); // 210mm
        const pageHeight = doc.internal.pageSize.getHeight(); // 297mm
        const imgProps = {
          width: pdfWidth,
          height: (canvas.height * pdfWidth) / canvas.width,
        };

        let position = 0;

        // If image height > one page height, split into pages
        if (imgProps.height < pageHeight) {
          doc.addImage(imgData, "PNG", 0, 0, imgProps.width, imgProps.height);
        } else {
          let remainingHeight = imgProps.height;

          while (remainingHeight > 0) {
            doc.addImage(
              imgData,
              "PNG",
              0,
              position,
              imgProps.width,
              imgProps.height,
            );
            remainingHeight -= pageHeight;
            position -= pageHeight;

            if (remainingHeight > 0) doc.addPage();
          }
        }

        const fileName = `${type === "invoice" ? "Invoice" : "Ticket"}_${
          booking.bookingName
        }.pdf`;
        doc.save(fileName);
      },
    );
    setLoading(false);
  };

  const generateTicketPDF = (booking) => {
    console.log("this is calling");
    // const templateId = `ticket-${booking._id}`;
    // const templateElement = document.getElementById(templateId);

    // if (!templateElement) {
    //   toast.error("Template not found!");
    //   return;
    // }

    // html2canvas(templateElement, { useCORS: true, scale: 2 }).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");

    //   const imgWidth = canvas.width;
    //   const imgHeight = canvas.height;

    //   // Convert px to mm
    //   const pdfWidth = imgWidth * 0.264583;
    //   const pdfHeight = imgHeight * 0.264583;

    //   const doc = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);

    //   doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    //   const fileName = `Ticket_${booking.bookingName}.pdf`;
    //   doc.save(fileName);
    // });
    const templateId = `ticket-${booking._id}`;
    const templateElement = document.getElementById(templateId);

    if (!templateElement) {
      toast.error("Template not found!");
      return;
    }

    html2canvas(templateElement, { useCORS: true, scale: 2 }).then((canvas) => {
      const image = canvas.toDataURL("image/png");

      // Create a temporary <a> tag to trigger download
      const link = document.createElement("a");
      link.href = image;
      link.download = `Ticket_${booking.bookingName}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleShowCancelModal = (booking) => {
    setSelectedBooking(booking);
    setCancellationReason("");
    setShowModal(true);
  };

  const handleCancelBooking = async () => {
    if (!cancellationReason.trim()) {
      toast.error("Please enter a cancellation reason.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URI}/booking/cancel-by-user/${selectedBooking._id}`,
        { cancellationReason },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("cine_userToken")}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success("Booking cancelled successfully!");
        setBookings(
          bookings.map((b) =>
            b._id === selectedBooking._id
              ? { ...b, isCancelled: true, status: "cancelled" }
              : b,
          ),
        );
        setShowModal(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to cancel booking!");
    }
  };

  const canCancel = (booking) => {
    if (booking.isCancelled) return false;

    const now = new Date();
    const bookingDateTime = new Date(booking.bookingDate);
    const [hours, minutes] = booking.startTime.split(":").map(Number);
    bookingDateTime.setHours(hours, minutes, 0, 0);

    const hoursDifference = (bookingDateTime - now) / (1000 * 60 * 60);
    return hoursDifference >= 72;
  };

  const AddOnServices = (booking) => {
    if (booking.isCancelled) return false;

    const now = new Date();
    const bookingDateTime = new Date(booking.bookingDate);
    const [hours, minutes] = booking.startTime.split(":").map(Number);
    bookingDateTime.setHours(hours, minutes, 0, 0);

    const hoursDifference = (bookingDateTime - now) / (1000 * 60 * 60);
    return hoursDifference >= 24;
  };

  // Check if booking can be rescheduled (12 hours before)
  const canReschedule = (booking) => {
    if (booking.isCancelled) return false;

    const now = new Date();
    const bookingDateTime = new Date(booking.bookingDate);
    const [hours, minutes] = booking.startTime.split(":").map(Number);
    bookingDateTime.setHours(hours, minutes, 0, 0);

    const hoursDifference = (bookingDateTime - now) / (1000 * 60 * 60);
    return hoursDifference >= 72;
  };

  // Open reschedule modal
  const handleShowRescheduleModal = (booking) => {
    setRescheduleBooking(booking);
    setRescheduleDate("");
    setRescheduleSlots([]);
    setRescheduleError(null);
    setSelectedSlotId("");
    setShowRescheduleModal(true);
  };

  // Fetch available slots for selected date
  const fetchAvailableSlots = async (date, subLocationId) => {
    setRescheduleLoading(true);
    setRescheduleError(null);
    setSelectedDate(date);

    // const formattedDate = getUTCDateFromISTDateString(date);

    try {
      const response = await axios.get(
        `${API_URI}/slot/withTheater?date=${date}&subLocationId=${subLocationId}`,
      );
      if (response.status === 200) {
        const data = response.data?.data;
        setTheaters(data);
        if (!selectedTheater) {
          setSelectedTheater(data[0]);
        }
        if (!selectedTheater.slots) {
          setSlots(data[0].slots);
          setSelectedSlot(data[0].slots[0]);
        }
        if (selectedTheater && selectedTheater._id) {
          const previouslySelectedTheater = data.find((theater) => {
            return theater.theater?._id === selectedTheater.theater?._id;
          });

          if (previouslySelectedTheater) {
            console.log(
              "Found previously selected theater, keeping it selected",
            );
            // Keep the same theater selected but update its slots
            setSelectedTheater(previouslySelectedTheater);
            setSlots(previouslySelectedTheater.slots || []);
          } else {
            console.log(
              "Previously selected theater not available for this date, clearing selection",
            );
            // If the previously selected theater is not available for this date, clear selection
            setSelectedTheater("");
            setSlots([]);
          }
        }
        // setRescheduleSlots(response.data.data || []);
      } else {
        // setRescheduleError("Failed to fetch slots.");
      }
    } catch (err) {
      setRescheduleError("Failed to fetch slots.");
    } finally {
      setRescheduleLoading(false);
    }
  };

  // Handle reschedule booking
  const handleRescheduleBooking = async () => {
    console.log("This is Calling.");
    if (!selectedTimeSlotId || !rescheduleDate || !selectedTheater) {
      toast.error("Please select a theater, slot and date.");
      return;
    }
    const token = localStorage.getItem("cine_userToken");
    if (!token) {
      setRescheduleActionLoading(false);
      toast.error("User authentication failed. Please login again.");
      setShowRescheduleModal(false);
      return;
    }
    setRescheduleActionLoading(true);

    // const formattedDate = getUTCDateFromISTDateString(rescheduleDate);
    try {
      const response = await axios.post(
        `${API_URI}/booking/reschedule-by-user`,
        {
          bookingId: rescheduleBooking._id,
          newTimeSlotId: selectedTimeSlotId,
          newBookingDate: rescheduleDate,
          newtheaterId: selectedTheater?.theater?._id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("cine_userToken")}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success("Booking rescheduled successfully!");
        setShowRescheduleModal(false);
        setSelectedSlotId("");
        // Refresh bookings
        const updatedResponse = await axios.get(`${API_URI}/booking/byself`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("cine_userToken")}`,
          },
        });
        if (updatedResponse.status === 200) {
          setBookings(updatedResponse.data.data);
        }
      } else {
        toast.error("Failed to reschedule booking.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to reschedule booking!",
      );
    } finally {
      setRescheduleActionLoading(false);
    }
  };

  console.log(slots);

  const getImageIndex = (theaterId) => theaterImageIndexes[theaterId] || 0;
  const findSlot = slots.find((slot) => slot._id == selectedSlot);

  console.log(findSlot, selectedSlotId);
  const cellStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    backgroundColor: "#f9f9f9",
    color: "#333",
  };

  const cellStyleRight = {
    ...cellStyle,
    textAlign: "right",
  };

  return (
    <>
      {/* <div className="updatedcards-booking">
        {loading ? (
          <Loader />
        ) : currentRecords.length > 0 ? (
          <>
            {currentRecords.map((booking) => (
              <div className="updated-bookingcard">
                <h6>Booking Name: {booking.bookingName}</h6>
                <p>
                  Date: {new Date(booking.bookingDate).toLocaleDateString()}
                </p>
                <p>Start Time: {booking.startTime}</p>
                <p>Number of People: {booking.numberOfPeople}</p>
                <p>Total Price: ₹{booking.totalPrice}</p>
                <br />
                {booking.addOnSubscriptions &&
                  booking.addOnSubscriptions.length > 0 && (
                    <div>
                      <h6>Add-On Services:</h6>
                      <ul>
                        {booking.addOnSubscriptions.map((addOn, index) => (
                          <li key={index}>
                            {addOn?.serviceId?.name} - ₹{addOn?.price}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                <div className="download-btns">
                  <Button
                    className="me-2 bt-line"
                    onClick={() => generatePDF(booking, "invoice")}
                  >
                    Download Invoice
                  </Button>
                  <Button
                    className="bt-line2"
                    onClick={() => generateTicketPDF(booking)}
                  >
                    Download Ticket
                  </Button>
                </div>

                {AddOnServices(booking) && (
                  <Button
                    className="ms-2 bt-line"
                    onClick={() => navigate(`/addOnServices/${booking._id}`)}
                  >
                    Add On Services
                  </Button>
                )}

                {canCancel(booking) && (
                  <Button
                    className="ms-2 btn-danger"
                    onClick={() => handleShowCancelModal(booking)}
                  >
                    Cancel Booking
                  </Button>
                )}

              
                {booking.isCancelled && (
                  <p className="text-danger mt-2">Booking Cancelled</p>
                )}
              </div>
            ))}
          </>
        ) : (
          <p className="text-muted text-center">No booking history found.</p>
        )}
      </div> */}

      <Card className="profile-booking-history-card shadow-lg mt-4">
        <Card.Header className="profile-booking-history-card__header">
          <div>
            <p className="profile-kicker mb-2">Your Moments</p>
            <h5 className="mb-0">Booking History</h5>
          </div>
        </Card.Header>
        <Card.Body className="profile-booking-history-card__body">
          {loading ? (
            <Loader />
          ) : currentRecords.length > 0 ? (
            <Row>
              {currentRecords.map((booking, index) => (
                <Col md={12} key={booking._id} className="mb-3">
                  <Card className="profile-booking-card">
                    <Card.Body className="profile-booking-card__body">
                      <div className="profile-booking-card__desktop">
                        <div className="profile-booking-card__top">
                          <div>
                            <p className="profile-kicker mb-2">Booking</p>
                            <h6 className="mb-1">{booking.bookingName}</h6>
                          </div>
                          <span
                            className={`profile-booking-status ${
                              booking.isCancelled ? "is-cancelled" : "is-active"
                            }`}
                          >
                            {booking.isCancelled ? "Cancelled" : "Confirmed"}
                          </span>
                        </div>

                        <div className="profile-booking-card__meta">
                          <div className="profile-booking-card__meta-item">
                            <span>Date</span>
                            <strong>
                              {new Date(booking.bookingDate).toLocaleDateString()}
                            </strong>
                          </div>
                          <div className="profile-booking-card__meta-item">
                            <span>Slot</span>
                            <strong>{getBookingTimeLabel(booking)}</strong>
                          </div>
                          <div className="profile-booking-card__meta-item">
                            <span>Guests</span>
                            <strong>{booking.numberOfPeople}</strong>
                          </div>
                          <div className="profile-booking-card__meta-item">
                            <span>Total</span>
                            <strong>
                              ₹
                              {(
                                parseFloat(booking.totalPrice) *
                                (1 + 0.02)
                              ).toFixed(2)}
                            </strong>
                          </div>
                        </div>

                        {booking.addOnSubscriptions &&
                          booking.addOnSubscriptions.length > 0 && (
                            <div className="profile-booking-card__addons">
                              <h6>Add-On Services</h6>
                              <ul>
                                {booking.addOnSubscriptions.map(
                                  (addOn, index) => (
                                    <li key={index}>
                                      {addOn?.serviceId?.name} - ₹{addOn?.price}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}
                        <div className="book-history-btn">
                          <Button
                            className="profile-history-action profile-history-action--primary"
                            onClick={() => generatePDF(booking, "invoice")}
                          >
                            Download Invoice
                          </Button>

                          <Button
                            className="profile-history-action profile-history-action--secondary"
                            onClick={() =>
                              navigate(`/addOnServices/${booking._id}`)
                            }
                          >
                            Add On Services
                          </Button>
                        </div>
                      </div>

                      <article className="profile-booking-mobile-card">
                        <div className="profile-booking-mobile-card__top">
                          <span className="profile-booking-mobile-card__index">
                            {String(indexOfFirstRecord + index + 1).padStart(2, "0")}
                          </span>
                          <span
                            className={`profile-booking-status ${
                              booking.isCancelled ? "is-cancelled" : "is-active"
                            }`}
                          >
                            {booking.isCancelled ? "Cancelled" : "Confirmed"}
                          </span>
                        </div>

                        <div className="profile-booking-mobile-card__body">
                          <span className="profile-booking-mobile-card__label">
                            Booking Name
                          </span>
                          <h5 className="mb-0">{booking.bookingName}</h5>

                          <div className="profile-booking-mobile-card__details">
                            <div className="profile-booking-mobile-card__line">
                              <span className="profile-booking-mobile-card__line-label">
                                Booking Info
                              </span>
                              <p className="mb-0">
                                {booking.theaterId?.name || "Selected Theater"}{" "}
                                {booking.numberOfPeople} guests
                              </p>
                            </div>

                            <div className="profile-booking-mobile-card__line">
                              <span className="profile-booking-mobile-card__line-label">
                                {new Date(booking.bookingDate).toLocaleDateString()} time
                              </span>
                              <p className="mb-0">{getBookingTimeLabel(booking)}</p>
                            </div>

                            {booking.addOnSubscriptions &&
                              booking.addOnSubscriptions.length > 0 && (
                                <div className="profile-booking-mobile-card__line">
                                  <span className="profile-booking-mobile-card__line-label">
                                    Add-ons
                                  </span>
                                  <p className="mb-0">
                                    {booking.addOnSubscriptions
                                      .map(
                                        (addOn) =>
                                          `${addOn?.serviceId?.name} - ₹${addOn?.price}`,
                                      )
                                      .join(", ")}
                                  </p>
                                </div>
                              )}
                          </div>
                        </div>

                        <div className="profile-booking-mobile-card__actions">
                          <Button
                            className="profile-history-action profile-history-action--primary"
                            onClick={() => generatePDF(booking, "invoice")}
                          >
                            Download Invoice
                          </Button>
                          <Button
                            className="profile-history-action profile-history-action--secondary"
                            onClick={() => navigate(`/addOnServices/${booking._id}`)}
                          >
                            Add On Services
                          </Button>
                        </div>
                      </article>

                      {/* {canCancel(booking) && (
                        <Button
                          className="ms-2 btn-danger"
                          onClick={() => handleShowCancelModal(booking)}
                        >
                          Cancel Booking
                        </Button>
                      )}

                      {canReschedule(booking) && (
                        <Button
                          className="ms-2 btn-warning"
                          onClick={() => handleShowRescheduleModal(booking)}
                        >
                          Reschedule Booking
                        </Button>
                      )} */}

                      {/* Show Cancelled Message if already cancelled */}
                    </Card.Body>
                    {/* Hidden templates for Invoice and Ticket */}
                    <div id={`invoice-${booking._id}`} className="hidden-template">
                      <div className="booking-invoice">
                        <div className="booking-invoice__hero">
                          <div className="booking-invoice__brand">
                            <img src={logo} alt="Cine Celebrate" />
                            <div>
                              <h2>Booking Invoice</h2>
                              <p>
                                Swastik Entertainments
                                <br />
                                GSTIN: 07AFKFS2510N1ZQ
                              </p>
                            </div>
                          </div>

                          <div className="booking-invoice__hero-side">
                            <div className="booking-invoice__pill">
                              <span>Invoice Date</span>
                              <strong>
                                {new Date(
                                  booking.bookingDate,
                                ).toLocaleDateString()}
                              </strong>
                            </div>
                            <div className="booking-invoice__contact">
                              <p>cinecelebrateglobal@gmail.com</p>
                              <p>+91-9643055509</p>
                            </div>
                          </div>
                        </div>

                        <div className="booking-invoice__summary">
                          <div className="booking-invoice__summary-card">
                            <span>Billed To</span>
                            <strong>Name</strong>
                            <p>{booking.bookingName}</p>
                            <strong>Contact</strong>
                            <p>
                              {booking.mobile ||
                                booking.contactNumber ||
                                booking.phone ||
                                booking.email ||
                                "Not available"}
                            </p>
                          </div>
                          <div className="booking-invoice__summary-card">
                            <span>Booking Info</span>
                            <strong>
                              {booking.theaterId?.name || "Selected Theater"} |{" "}
                              {booking.numberOfPeople} Guests
                            </strong>
                            <p>
                              {new Date(
                                booking.bookingDate,
                              ).toLocaleDateString()}{" "}
                              | {getBookingTimeLabel(booking)}
                            </p>
                            {Number(booking.pricingDetails?.decorCost || 0) >
                              0 && (
                              <p>
                                Decoration | Rs.{" "}
                                {Number(
                                  booking.pricingDetails?.decorCost || 0,
                                ).toFixed(2)}
                              </p>
                            )}
                          </div>
                        </div>

                        <section className="booking-invoice__section">
                          <div className="booking-invoice__section-head">
                            <h4>Payment Summary</h4>
                          </div>
                          <table className="booking-invoice__table">
                            <tbody>
                              <tr>
                                <td>Pre-Booking Paid Amount</td>
                                <td>
                                  Rs. {Number(booking.paymentAmount || 0).toFixed(2)}
                                </td>
                              </tr>
                              {booking.addOnSubscriptions?.length > 0 && (
                                <tr>
                                  <td>Add-On Services Payment</td>
                                  <td>
                                    Rs.{" "}
                                    {Number(
                                      booking.addOnServiceBreakdown?.finalTotal || 0,
                                    ).toFixed(2)}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </section>

                        <section className="booking-invoice__section">
                          <div className="booking-invoice__section-head">
                            <h4>Booking Summary</h4>
                          </div>
                          <table className="booking-invoice__table">
                            <tbody>
                              <tr>
                                <td>Slot Amount</td>
                                <td>
                                  Rs.{" "}
                                  {Number(
                                    booking.pricingDetails?.baseSlotPrice || 0,
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              {Number(
                                booking.pricingDetails?.additionalPeopleCost || 0,
                              ) > 0 && (
                                <tr>
                                  <td>
                                    <div className="booking-invoice__cell-stack">
                                      <span>Extra Guest Charges</span>
                                      <small>
                                        Rs.{" "}
                                        {Number(
                                          booking.pricingDetails
                                            ?.additionalCostPerPerson || 0,
                                        ).toFixed(2)}
                                        *{booking.pricingDetails?.extraPeopleCount || 0}{" "}
                                        = Rs.{" "}
                                        {Number(
                                          booking.pricingDetails
                                            ?.additionalPeopleCost || 0,
                                        ).toFixed(2)}
                                      </small>
                                    </div>
                                  </td>
                                  <td>
                                    Rs.{" "}
                                    {Number(
                                      booking.pricingDetails?.additionalPeopleCost || 0,
                                    ).toFixed(2)}
                                  </td>
                                </tr>
                              )}
                              {Number(booking.pricingDetails?.decorCost || 0) > 0 && (
                                <tr>
                                  <td>Decoration</td>
                                  <td>
                                    Rs.{" "}
                                    {Number(
                                      booking.pricingDetails?.decorCost || 0,
                                    ).toFixed(2)}
                                  </td>
                                </tr>
                              )}
                              {Number(
                                booking.pricingDetails?.discountAmount || 0,
                              ) > 0 && (
                                <tr>
                                  <td>
                                    Discount
                                    {booking.pricingDetails?.couponCode
                                      ? ` (${booking.pricingDetails.couponCode})`
                                      : booking.couponCode
                                        ? ` (${booking.couponCode})`
                                        : ""}
                                  </td>
                                  <td>
                                    - Rs.{" "}
                                    {Number(
                                      booking.pricingDetails?.discountAmount || 0,
                                    ).toFixed(2)}
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td>Gateway Charges @ 2%</td>
                                <td>
                                  Rs.{" "}
                                  {(
                                    (booking.pricingDetails?.taxBreakdown
                                      ?.platformFee || 0) +
                                    (booking.addOnServiceBreakdown?.platformFee || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              <tr className="booking-invoice__table-total">
                                <td>Total Amount</td>
                                <td>
                                  Rs.{" "}
                                  {Number(
                                    booking.pricingDetails?.finalTotal || 0,
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </section>

                        <section className="booking-invoice__section">
                          <div className="booking-invoice__section-head">
                            <h4>Tax Analysis</h4>
                          </div>
                          <table className="booking-invoice__table">
                            <tbody>
                              <tr>
                                <td>Taxable Amount</td>
                                <td>
                                  Rs.{" "}
                                  {(
                                    (booking.pricingDetails?.taxBreakdown
                                      ?.baseAmount || 0) +
                                    (booking.addOnServiceBreakdown?.baseAmount || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>SGST @ 9%</td>
                                <td>
                                  Rs.{" "}
                                  {(
                                    (booking.pricingDetails?.taxBreakdown?.sgst || 0) +
                                    (booking.addOnServiceBreakdown?.sgst || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>CGST @ 9%</td>
                                <td>
                                  Rs.{" "}
                                  {(
                                    (booking.pricingDetails?.taxBreakdown?.cgst || 0) +
                                    (booking.addOnServiceBreakdown?.cgst || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                              <tr className="booking-invoice__table-total">
                                <td>Total Amount</td>
                                <td>
                                  Rs.{" "}
                                  {(
                                    (booking.pricingDetails?.taxBreakdown
                                      ?.finalTotal || 0) +
                                    (booking.addOnServiceBreakdown?.finalTotal || 0)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </section>

                        <div className="booking-invoice__footer">
                          Thank you for booking with Cine Celebrate. For any
                          help, contact +91-9643055509.
                        </div>
                      </div>
                    </div>

                    <div
                      id={`ticket-${booking._id}`}
                      className="hidden-template"
                      style={{
                        fontFamily: "Arial, sans-serif",
                        // width: "297mm",
                        margin: "0 auto",
                        padding: "15mm",
                        backgroundColor: "#ffffff",
                        // border: "2px dashed #E89897",
                        borderRadius: "10px",
                        textAlign: "center",
                        maxHeight: "500px",
                      }}
                    >
                      {/* <div className="new-ticket">
                        <span className="ticket-nov-10">Event Ticket</span>

                        <div className="ticket-show-name">
                          <h1>{booking.theaterId?.name}</h1>
                        </div>
                        <div className="ticket-time">
                          <p>
                            {booking.startTime} <span>TO</span>{" "}
                            {booking.endTime}
                          </p>
                        </div>
                        <div className="ticket-tagline">
                          <p>{booking.bookingName}</p>
                        </div>
                      </div> */}

                      <div
                        style={{
                          display: "flex",
                          width: "600px",
                          margin: "20px auto",
                          borderRadius: "20px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          fontFamily: "Arial, sans-serif",
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            background:
                              "linear-gradient(135deg, #F6B1B1, #E89897)",
                            position: "relative",
                            minHeight: "250px",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              bottom: "40px",
                              left: "40px",
                              backgroundColor: "#fff",
                              padding: "5px",
                              borderRadius: "8px",
                            }}
                          >
                            <img
                              src={logo}
                              alt="logo"
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "contain",
                              }}
                            />
                            {/* <QRCodeCanvas
                              value={`https://yourdomain.com/ticket/${booking._id}`}
                              size={150}
                              bgColor="#ffffff"
                              fgColor="#000000"
                            /> */}
                          </div>
                        </div>
                        <div
                          style={{
                            width: "5px",
                            background:
                              "repeating-linear-gradient(#000, #000 20px, transparent 20px, transparent 40px)",
                          }}
                        ></div>

                        <div
                          style={{
                            width: "60%",
                            background:
                              "linear-gradient(135deg, #F6B1B1, #E89897)",
                            color: "#fff",
                            padding: "20px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            textAlign: "left",
                            position: "relative",
                          }}
                        >
                          <img
                            src={logo}
                            alt="logo"
                            style={{
                              position: "absolute",
                              top: "15px",
                              right: "15px",
                              width: "50px",
                              height: "50px",
                              objectFit: "contain",
                            }}
                          />
                          <p style={{ fontSize: "14px", margin: 0 }}>
                            Event Ticket
                          </p>
                          <h2
                            style={{ fontSize: "22px", margin: "5px 0 10px" }}
                          >
                            {booking.theaterId?.name}
                          </h2>
                          <p style={{ fontSize: "16px", margin: "5px 0" }}>
                            <strong>Time:</strong> {booking.startTime} TO{" "}
                            {booking.endTime}
                          </p>
                          <p style={{ fontSize: "16px", margin: "5px 0" }}>
                            <strong>Date:</strong>{" "}
                            {new Date(booking.bookingDate).toLocaleDateString(
                              "en-GB",
                            )}
                          </p>
                          <p style={{ fontSize: "16px", margin: "5px 0" }}>
                            <strong>Customer:</strong> {booking.bookingName}
                          </p>
                        </div>
                      </div>

                      {/* <div className="ticket-container">
                        <div className="ticket-left">
                          <div className="ticket-image">
                            <p className="ticket-admit-one">
                              <span>Event Ticket</span>
                              <span>Event Ticket</span>
                              <span>Event Ticket</span>
                            </p>
                            <div className="ticket-number">
                              <p>#20231304</p>
                            </div>
                          </div>
                          <div className="ticket-info">
                            <p className="ticket-date">
                              <span>Event</span>
                              <span className="ticket-nov-10">
                                Event Ticket
                              </span>
                              <span>Ticket</span>
                            </p>
                            <div className="ticket-show-name">
                              <h1>{booking.theaterId?.name}</h1>
                            </div>
                            <div className="ticket-time">
                              <p>
                                {booking.startTime} <span>TO</span>{" "}
                                {booking.endTime}
                              </p>
                            </div>
                            <div className="ticket-tagline">
                              <p>{booking.bookingName}</p>
                            </div>
                            <p
                              style={{
                                fontSize: "12px",
                                color: "#666",
                                marginTop: "10px"
                              }}
                            >
                              Show this ticket at the entrance for admission.
                            </p>
                          </div>
                        </div>
                        <div className="ticket-right">
                          <p className="ticket-admit-one">
                            <span>Event Ticket</span>
                            <span>Event Ticket</span>
                            <span>Event Ticket</span>
                          </p>
                          <div className="ticket-right-info-container">
                            <div className="ticket-show-name">
                              <h1>#CineCelebrate</h1>
                            </div>
                            <div className="ticket-time">
                              <p>
                                {booking.startTime} <span>TO</span>{" "}
                                {booking.endTime}
                              </p>
                            </div>
                            <div className="ticket-barcode">
                              thisi section for barcode
                            </div>
                            {booking.addOnSubscriptions &&
                              booking.addOnSubscriptions.length > 0 && (
                                <div
                                  style={{
                                    backgroundColor: "#f9f9f9",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    marginBottom: "15px"
                                  }}
                                >
                                  <h2
                                    style={{
                                      fontSize: "18px",
                                      color: "#333",
                                      marginBottom: "5px"
                                    }}
                                  >
                                    Add-On Services
                                  </h2>
                                  <ul
                                    style={{
                                      listStyleType: "none",
                                      padding: 0,
                                      margin: 0
                                    }}
                                  >
                                    {booking.addOnSubscriptions.map(
                                      (addOn, index) => (
                                        <li
                                          key={index}
                                          style={{
                                            fontSize: "14px",
                                            color: "#555",
                                            padding: "5px 0",
                                            borderBottom: "1px solid #ddd"
                                          }}
                                        >
                                          {addOn?.serviceId?.name} - ₹
                                          {addOn?.price}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              )}
                            <p className="ticket-number">#20231304</p>
                          </div>
                        </div>
                      </div> */}
                      {/* <h1
                      style={{
                        fontSize: "24px",
                        color: "#E89897",
                        marginBottom: "10px"
                      }}
                    >
                      Event Ticket
                    </h1>
                    <div style={{ marginBottom: "15px" }}>
                      <p>
                        <strong>Booking Name:</strong> {booking.bookingName}
                      </p>
                      <p>
                        <strong>Theater:</strong> {booking.theaterId?.name}
                      </p>
                      <p>
                        <strong>Date:</strong>{" "}
                        {new Date(booking.bookingDate).toLocaleDateString()}
                      </p>
                      <p>
                        <strong>Start Time:</strong> {booking.startTime}
                      </p>
                      <p>
                        <strong>End Time:</strong> {booking.endTime}
                      </p>

                    </div>
                    {booking.addOnSubscriptions &&
                      booking.addOnSubscriptions.length > 0 && (
                        <div
                          style={{
                            backgroundColor: "#f9f9f9",
                            padding: "10px",
                            borderRadius: "8px",
                            marginBottom: "15px"
                          }}
                        >
                          <h2
                            style={{
                              fontSize: "18px",
                              color: "#333",
                              marginBottom: "5px"
                            }}
                          >
                            Add-On Services
                          </h2>
                          <ul
                            style={{
                              listStyleType: "none",
                              padding: 0,
                              margin: 0
                            }}
                          >
                            {booking.addOnSubscriptions.map((addOn, index) => (
                              <li
                                key={index}
                                style={{
                                  fontSize: "14px",
                                  color: "#555",
                                  padding: "5px 0",
                                  borderBottom: "1px solid #ddd"
                                }}
                              >
                                {addOn?.serviceId?.name} - ₹{addOn?.price}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )} */}
                      {/* <div
                      style={{
                        margin: "0 auto",
                        width: "200px",
                        height: "200px",
                        border: "1px dashed #E89897",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#888"
                        }}
                      >
                        QR Code Placeholder
                      </p>
                    </div> */}
                      {/* <p
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "10px"
                      }}
                    >
                      Show this ticket at the entrance for admission.
                    </p> */}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <p className="text-muted text-center">No booking history found.</p>
          )}

          {/* Pagination */}
          {/* <Pagination className="justify-content-center mt-3">
          {[...Array(totalPages).keys()].map((number) => (
            <Pagination.Item
              key={number + 1}
              active={currentPage === number + 1}
              onClick={() => handlePageChange(number + 1)}>
              {number + 1}
            </Pagination.Item>
          ))}
        </Pagination> */}
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Reason for Cancellation</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={cancellationReason}
              onChange={(e) => setCancellationReason(e.target.value)}
              placeholder="Enter your reason for cancellation..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="danger" onClick={handleCancelBooking}>
            Confirm Cancellation
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reschedule Modal */}
      <Modal
        show={showRescheduleModal}
        onHide={() => setShowRescheduleModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reschedule Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select New Date</Form.Label>
            <Form.Control
              type="date"
              value={rescheduleDate}
              min={new Date().toISOString().split("T")[0]}
              onChange={async (e) => {
                setRescheduleDate(e.target.value);
                setSelectedSlotId("");
                if (
                  e.target.value &&
                  rescheduleBooking?.theaterId?.subLocationId
                ) {
                  await fetchAvailableSlots(
                    e.target.value,
                    rescheduleBooking.theaterId.subLocationId,
                  );
                } else {
                  setRescheduleSlots([]);
                }
              }}
            />
          </Form.Group>

          {rescheduleLoading && (
            <div className="text-center">
              <Loader />
              <p>Loading available slots...</p>
            </div>
          )}

          {rescheduleError && (
            <div className="alert alert-danger">{rescheduleError}</div>
          )}

          {/* {rescheduleSlots?.slots?.length > 0 && (
            <Form.Group className="mb-3">
              <Form.Label>Available Slots:</Form.Label>
              <div className="d-flex flex-column gap-2">
                {rescheduleSlots.slots
                  .filter(slot => slot.isAvailable && slot.timeSlotId === rescheduleBooking.timeSlotId)
                  .map((slot) => (
                    <Form.Check
                      key={slot._id}
                      type="radio"
                      name="slot"
                      id={`slot-${slot._id}`}
                      label={`${slot.startTime} - ${slot.endTime}`}
                      checked={selectedSlotId === slot.timeSlotId}
                      onChange={() => setSelectedSlotId(slot.timeSlotId)}
                    />
                  ))}
                {rescheduleSlots.slots.filter(slot => slot.isAvailable).length === 0 && (
                  <div className="text-muted">No available slots for this date.</div>
                )}
              </div>
            </Form.Group>
          )} */}
          <br />
          <h3>Select Theater</h3>
          <div>
            <div className="updated-Theaters">
              {theaters.map((theater) => {
                const images = theater.theater.imageUrls;
                const imgIndex = getImageIndex(theater._id);

                const sortedSlots = theater.theater.timeSlots.sort(
                  (a, b) => a.price - b.price,
                );
                const bestSlot =
                  sortedSlots.find((slot) => slot._id === selectedTimeSlotId) ||
                  sortedSlots[0];

                if (!bestSlot) return null; // No slots

                const {
                  price,
                  strikePrice,
                  maxPeople,
                  additionalCostPerPerson,
                } = bestSlot;
                const offerAmount = strikePrice - price;

                return (
                  <div
                    className={`updated-Theater ${
                      selectedTheater?.theater?._id === theater?.theater?._id
                        ? "bg-selected"
                        : ""
                    }`}
                    onClick={() => handleTheaterSelect(theater)}
                    key={theater._id + Math.random()}
                    style={{
                      border: "1px solid #f0a0a0",
                      borderRadius: "10px",
                      padding: "15px",
                      marginBottom: "15px",
                      backgroundColor:
                        selectedTheater?.theater?._id === theater?.theater?._id
                          ? "#ffe8e8"
                          : "#fff",
                      cursor: "pointer",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                  >
                    {/* Image Section */}
                    <div
                      className="updated-Theater-img"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {images.length > 0 && (
                        <Carousel
                          interval={1000}
                          controls={images.length > 1}
                          controls={false}
                          indicators={false}
                          fade
                          style={{
                            width: "120px",
                            height: "100px",
                            margin: "auto",
                          }}
                        >
                          {images.map((imgUrl, index) => (
                            <Carousel.Item key={index}>
                              <img
                                src={imgUrl}
                                alt={`Slide ${index + 1}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  margin: "auto",
                                }}
                              />
                            </Carousel.Item>
                          ))}
                        </Carousel>
                      )}
                    </div>
                    <div
                      className="updated-Theater-text"
                      style={{ marginTop: "10px" }}
                    >
                      <p
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          marginBottom: "5px",
                        }}
                      >
                        {theater.theater.name}
                      </p>
                      <p style={{ marginBottom: "6px" }}>
                        {theater?.theater?.timeSlots[0]?.defaultPeople} people
                      </p>

                      <p style={{ margin: "4px 0" }}>
                        <span
                          style={{
                            textDecoration: "line-through",
                            marginRight: "5px",
                          }}
                        >
                          ₹{strikePrice}
                        </span>
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                          }}
                        >
                          ₹{price}
                        </span>
                      </p>

                      {offerAmount > 0 && (
                        <p
                          style={{
                            color: "#ca5052ff",
                            fontSize: "14px",
                            marginBottom: "4px",
                          }}
                        >
                          Save ₹{offerAmount}!
                        </p>
                      )}

                      <p style={{ fontSize: "14px", marginBottom: "3px" }}>
                        Max People: {maxPeople}
                      </p>
                      {theater?.theater?.timeSlots[0]?.defaultPeople <
                        maxPeople && (
                        <p style={{ fontSize: "14px", color: "#555" }}>
                          Additional Person: ₹{additionalCostPerPerson}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <br />

          <Col md={6} lg={6} className="mb-4">
            <Card className=" p-3 shadow-sm">
              <Card.Body>
                <h6 style={{ textAlign: "center" }}>Available Slots</h6>
                {loading && (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}
                {!loading && slots && slots.length > 0 ? (
                  <Row className="g-2">
                    {slots.map((slot) => {
                      const currentTime = new Date();
                      const [hours, minutes] = slot.startTime.split(":");
                      const slotStartTime = new Date(selectedDate);
                      slotStartTime.setHours(parseInt(hours));
                      slotStartTime.setMinutes(parseInt(minutes));
                      slotStartTime.setSeconds(0);
                      slotStartTime.setMilliseconds(0);

                      const isPast = currentTime > slotStartTime;
                      const isSlotAvailable = slot.isAvailable && !isPast;
                      return (
                        <Col md={6} lg={4} key={slot._id}>
                          <Card
                            className=" text-center shadow-sm"
                            // onClick={
                            //   slot.isAvailable
                            //     ? () => handleSlotClick(slot._id)
                            //     : null
                            // }
                            onClick={
                              isSlotAvailable
                                ? () => {
                                    handleSlotClick(slot);
                                  }
                                : null
                            }
                            style={{
                              cursor: isSlotAvailable
                                ? "pointer"
                                : "not-allowed",
                              background:
                                selectedSlot === slot._id
                                  ? "linear-gradient(90deg, #FFB284 0%, #E89897 100%)"
                                  : "white",
                              color:
                                selectedSlot === slot._id ? "white" : "black",
                              border:
                                selectedSlot === slot._id
                                  ? "none"
                                  : "1px solid #ddd",
                              padding: "15px 0",
                            }}
                          >
                            <Card.Text
                              className="fw-bold"
                              style={{ fontSize: "12px" }}
                            >
                              {slot.startTime} - {slot.endTime}
                            </Card.Text>
                            <Card.Text>
                              {isSlotAvailable ? "Available" : "Not Available"}
                            </Card.Text>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                ) : (
                  <p>No slots available</p>
                )}
              </Card.Body>
            </Card>
          </Col>

          {rescheduleBooking && (
            <div className="error-message">
              <strong>Current Booking Details:</strong>
              <br />
              Date:{" "}
              {new Date(rescheduleBooking.bookingDate).toLocaleDateString()}
              <br />
              Time: {rescheduleBooking.startTime} - {rescheduleBooking.endTime}
              <br />
              Theater: {rescheduleBooking.theaterId?.name}
            </div>
          )}
          <br />

          {selectedTheater && (
            <div className="alert alert-info">
              <strong>Rescheduling Booking Details:</strong>
              <br />
              Date: {new Date(selectedDate).toLocaleDateString()}
              <br />
              Time: {findSlot?.startTime} - {findSlot?.endTime}
              <br />
              Theater: {selectedTheater?.theater?.name}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowRescheduleModal(false)}
            disabled={rescheduleActionLoading}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleRescheduleBooking}
            disabled={!selectedSlot || rescheduleActionLoading}
          >
            {rescheduleActionLoading ? "Rescheduling..." : "Reschedule Booking"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BookingHistory;

{
  /* {booking.addOnSubscriptions &&
                        booking.addOnSubscriptions.length > 0 && (
                          <section style={{ marginTop: "20px" }}>
                            <h2
                              style={{
                                fontSize: "18px",
                                marginBottom: "10px",
                                color: "#333"
                              }}
                            >
                              Add-On Services
                            </h2>
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse"
                              }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      backgroundColor: "#f2f2f2"
                                    }}
                                  >
                                    Service
                                  </th>
                                  <th
                                    style={{
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      backgroundColor: "#f2f2f2"
                                    }}
                                  >
                                    Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {booking.addOnSubscriptions.map(
                                  (addOn, index) => (
                                    <tr key={index}>
                                      <td
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd"
                                        }}
                                      >
                                        {addOn?.serviceId?.name}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd"
                                        }}
                                      >
                                        ₹{addOn?.price}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </section>
                        )}
                      {booking.addOnServiceBreakdown?.finalTotal > 0 && (
                        <section style={{ marginTop: "20px" }}>
                          <h2
                            style={{
                              fontSize: "18px",
                              marginBottom: "10px",
                              color: "#333"
                            }}
                          >
                            Add-On Services Tax Breakdown
                          </h2>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse"
                            }}
                          >
                            <tbody>
                              <tr>
                                <td style={cellStyle}>Base Amount</td>
                                <td style={cellStyleRight}>
                                  ₹
                                  {booking.addOnServiceBreakdown.baseAmount?.toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={cellStyle}>CGST (9%)</td>
                                <td style={cellStyleRight}>
                                  ₹
                                  {booking.addOnServiceBreakdown.cgst?.toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={cellStyle}>SGST (9%)</td>
                                <td style={cellStyleRight}>
                                  ₹
                                  {booking.addOnServiceBreakdown.sgst?.toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={cellStyle}>Platform Fee (2%)</td>
                                <td style={cellStyleRight}>
                                  ₹
                                  {booking.addOnServiceBreakdown.platformFee?.toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{ ...cellStyle, fontWeight: "bold" }}
                                >
                                  Final Total
                                </td>
                                <td
                                  style={{
                                    ...cellStyleRight,
                                    fontWeight: "bold"
                                  }}
                                >
                                  ₹
                                  {booking.addOnServiceBreakdown.finalTotal?.toFixed(
                                    2
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </section>
                      )} */
}

{
  /* {booking.pricingDetails?.taxBreakdown && (
                                <section style={{ marginTop: "20px" }}>
                                  <h2
                                    style={{
                                      fontSize: "18px",
                                      marginBottom: "10px",
                                      color: "#333"
                                    }}
                                  >
                                    Booking Tax Breakdown
                                  </h2>
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse"
                                    }}
                                  >
                                    <tbody>
                                      <tr>
                                        <td style={cellStyle}>Base Amount</td>
                                        <td style={cellStyleRight}>
                                          ₹
                                          {booking.pricingDetails.taxBreakdown.baseAmount?.toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={cellStyle}>CGST (9%)</td>
                                        <td style={cellStyleRight}>
                                          ₹
                                          {booking.pricingDetails.taxBreakdown.cgst?.toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={cellStyle}>SGST (9%)</td>
                                        <td style={cellStyleRight}>
                                          ₹
                                          {booking.pricingDetails.taxBreakdown.sgst?.toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={cellStyle}>
                                          Platform Fee (2%)
                                        </td>
                                        <td style={cellStyleRight}>
                                          ₹
                                          {booking.pricingDetails.taxBreakdown.platformFee?.toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          style={{
                                            ...cellStyle,
                                            fontWeight: "bold"
                                          }}
                                        >
                                          Final Total
                                        </td>
                                        <td
                                          style={{
                                            ...cellStyleRight,
                                            fontWeight: "bold"
                                          }}
                                        >
                                          ₹
                                          {booking.pricingDetails.taxBreakdown.finalTotal?.toFixed(
                                            2
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </section>
                              )} */
}
